import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"

export const DesktopSortContainer = styled("div")`
    padding: 0;
    @media (max-width: ${breakpoints.values.lg - 1}px) {
        display: none;
    }
`
export default DesktopSortContainer
